const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaoWinner',
    accessToken: 'accessTokenLaoWinner',
    userRole: 'userRole',
  }
}

export default AppConfig;
